"use client";
import IconLabel from "@/icons/IconLabel";

import DesignAction from "./DesignAction";

import Link from "next/link";
import { EntranceDiv } from "@/components/motion/legacy-entrances";
import { CtaComponentProps } from "@/cms/models";
import {
  getBorderRadius,
  getDesktop,
  getDesktopSize,
  getMargins,
  getMobile,
  getMobileSize,
  getPaddings,
  getTextSize,
} from "@/utils/theme-helper";

const CtaComponent: React.FC<{
  config: CtaComponentProps;
  id: string;
  itemIndex: number;
}> = ({ config, id, itemIndex }) => {
  const mobileWidth = getMobile("none", config.width);
  const desktopWidth = getDesktop("none", config.width);
  const mobileHeight = getMobile("none", config.height);
  const desktopHeight = getDesktop("none", config.height);

  let disableAnimation = config.disableAnimation;
  // Temp always disable animation
  disableAnimation = true;

  if (config.variant) return <DesignAction config={config} />;
  return (
    <div
      data-type="CtaComponent"
      className={`flex ${getTextSize(config.size)} ${getMargins(config.margin)} justify-${config.justify} ${mobileWidth !== "none" ? "w-[var(--mobile-width)]" : ""} ${desktopWidth !== "none" ? "md:w-[var(--desktop-width)]" : ""} ${mobileHeight !== "none" ? "h-[var(--mobile-height)]" : ""} ${desktopHeight !== "none" ? "md:h-[var(--desktop-height)]" : ""}`}
      style={
        {
          "--mobile-width": mobileWidth,
          "--desktop-width": desktopWidth,
          "--mobile-height": mobileHeight,
          "--desktop-height": desktopHeight,
        } as React.CSSProperties
      }
    >
      <EntranceDiv
        initial={disableAnimation ? undefined : "initial"}
        whileInView={disableAnimation ? undefined : "animate"}
        className={id}
        viewport={{
          once: true,
        }}
        variants={{
          initial: {
            opacity: 0,
            y: 100,
          },
          animate: () => ({
            opacity: 1,
            y: 0,
            transition: {
              delay: 0.05 * itemIndex,
            },
          }),
        }}
      >
        <Link
          href={config.link}
          data-re-press={config.lookSystem ? "" : undefined}
          style={
            {
              "--cta-text-color": config.textColor,
              "--cta-bg-color": config.bgColor,
              "--cta-border-color": config.borderColor,
              "--cta-hover-border-color": config.hoverBorderColor,
              "--cta-hover-bg-color": config.hoverBgColor,
              "--cta-hover-text-color": config.hoverTextColor,
              "--rounding-mobile": getBorderRadius(
                getMobile("", config.rounded),
                "button",
                config.lookSystem,
              ),
              "--rounding-desktop": getBorderRadius(
                getDesktop("", config.rounded),
                "button",
                config.lookSystem,
              ),
            } as React.CSSProperties
          }
          className={`homepage-rounded border border-[var(--cta-border-color)] hover:border-[var(--cta-hover-border-color)] ${config.padding ? getPaddings(config.padding) : "px-3 py-2"} hover:text-[var(--cta-hover-text-color)] hover:bg-[var(--cta-hover-bg-color)]  bg-[var(--cta-bg-color)] text-[var(--cta-text-color)] flex justify-center lg:min-w-[122px] text-${getMobileSize(config.size)} md:text-${getDesktopSize(config.size)}`}
        >
          <IconLabel
            iconId={config.iconId}
            position={config.iconPosition}
            lookSystem={config.lookSystem}
          >
            {config.label}
          </IconLabel>
        </Link>
      </EntranceDiv>
    </div>
  );
};

export default CtaComponent;
